export const formatBetNumber = (value) => /^\d+$/.test(String(value)) ? String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',') : value;